import Pricing from './PricingContainer.vue';

export { Pricing };



// WEBPACK FOOTER //
// ./src/modules/home/pricing/index.js